var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightGridImageMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 523,
    viewBox: "0 0 541 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1405_22995)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.16,
    cy: 195.677,
    rx: 65.3076,
    ry: 138.564,
    transform: "rotate(-135 144.16 195.677)",
    fill: "url(#paint0_linear_1405_22995)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 83.3906,
    y1: 10.0234,
    x2: 83.3907,
    y2: 499.999,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.008,
    y1: 2.17535e-8,
    x2: 125.008,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.633,
    y1: 2.17535e-8,
    x2: 166.633,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.258,
    y1: 2.17535e-8,
    x2: 208.258,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.875,
    y1: 2.17535e-8,
    x2: 249.875,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.5,
    y1: 2.17535e-8,
    x2: 291.5,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.125,
    y1: 2.17535e-8,
    x2: 333.125,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.742,
    y1: 2.17535e-8,
    x2: 374.742,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 416.367,
    y1: 2.17535e-8,
    x2: 416.367,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 457.992,
    y1: 2.17535e-8,
    x2: 457.992,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.609,
    y1: 2.17535e-8,
    x2: 499.609,
    y2: 500,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 39.75,
    x2: 41,
    y2: 39.75,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 81.6133,
    x2: 41,
    y2: 81.6132,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 123.477,
    x2: 41,
    y2: 123.477,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 165.336,
    x2: 41,
    y2: 165.336,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 207.199,
    x2: 41,
    y2: 207.199,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 249.062,
    x2: 41,
    y2: 249.062,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 290.922,
    x2: 41,
    y2: 290.922,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 332.785,
    x2: 41,
    y2: 332.785,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 374.648,
    x2: 41,
    y2: 374.648,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 416.508,
    x2: 41,
    y2: 416.508,
    stroke: "#7551FF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 458.371,
    x2: 41,
    y2: 458.371,
    stroke: "#7551FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right-grid-star"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.164 485.404C69.2347 484.808 70.0995 484.808 70.1703 485.404L70.7635 490.404C71.5295 496.859 76.6194 501.949 83.0752 502.715L88.0747 503.308C88.6708 503.379 88.6708 504.244 88.0747 504.315L83.0752 504.908C76.6194 505.674 71.5295 510.764 70.7635 517.22L70.1703 522.219C70.0995 522.815 69.2347 522.815 69.164 522.219L68.5707 517.22C67.8047 510.764 62.7148 505.674 56.259 504.908L51.2595 504.315C50.6635 504.244 50.6635 503.379 51.2595 503.308L56.259 502.715C62.7148 501.949 67.8047 496.859 68.5707 490.404L69.164 485.404Z",
    fill: "#7551FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1405_22995",
    x: 34.0155,
    y: 85.5312,
    width: 220.289,
    height: 220.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.902389,
    result: "effect1_foregroundBlur_1405_22995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1405_22995",
    x1: 86.7561,
    y1: 106.912,
    x2: 227.028,
    y2: 242.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCF9FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7551FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGridImageMobile);
export default __webpack_public_path__ + "static/media/RightGridImageMobile.e40fe25c4ca1c91d7f32e759d86bfa4b.svg";
export { ForwardRef as ReactComponent };